// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

export interface IBubbleTextFieldSchema {
  /** Имя кнопки **/
  buttonName: string;
  /** Подсказка для поля ввода **/
  hint?: string;
  /** Вариант который надо отправить по socket-у **/
  socketPayload: ESocketPayload;
  /** Тип поля ввода **/
  textFieldType?: ETextFieldType;
}
export enum ESocketPayload {
  /** Не запрашивать контакты пользователя **/
  'Request_contacts.dont_show' = 'request_contacts.dont_show',
  /** Запрос контактов пользователя **/
  'Request_contacts.show' = 'request_contacts.show',
  /** Добавить имя пользователя **/
  'Request_name.add' = 'request_name.add',
}
export enum ETextFieldType {
  /** Текстовое поле ввода **/
  'Text' = 'text',
}
